import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import _ from 'lodash';
import { Table, Icon, Row, Button, Modal, Spin, Tooltip, Col } from 'antd';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../index';
import styles from '../styles.less';
import { PencilIcon, TrashIcon } from '../../Icons';
import MultiplyItemsColumnRender from '../../common/Table/MultiplyItemsColumnRender';


class ProjectsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: '0',
      filter: {
        search: undefined,
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.AccountSettings.List.Title',
        description: 'Component.AccountSettings.List.Description1',
      },
    });
  }

  getData(psf) {
    const filter = { name: this.state.filter.search, client_id: this.props.app.selectedClient.id };
    const payload = { filter, ...psf };
    return this.props.dispatch({ type: 'projects/loadProjectsList', payload });
  }

  showDeleteConfirm = (record) => {
    const self = this;
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage({ id: 'Component.AccountSettings.Remove.Modal.Description' }, { projectName: record.domain }),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk() {
        self.remove(record.id);
      },
    });
  }

  remove(id) {
    this.props.dispatch({ type: 'projects/remove', payload: { id } }).then(() => {
      this.props.dispatch({ type: 'app/showNotifications' });
      this.setState({ removedId: id });
    });
  }

  checkColumnData(arr, renderHTML) {
    return arr.length ? renderHTML : <FormattedMessage id="Common.NoData" />;
  }

  render() {
    const { Column } = Table;

    return (
      <div className={[styles.containerLarge, styles.containerProject].join(' ')}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent
                self={this}
                fieldPlaceholder={this.props.intl.formatMessage({
                  id: 'Component.AccountSettings.List.SearchPlaceholder',
                })}
              />
              <Col span={14} className="text-right">
                {this.props.app.user.super_admin && (
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => this.props.dispatch({
                      type: 'app/goToRoute',
                      payload: { routeName: 'ACCOUNT_NEW' },
                    })}
                  >
                    <Icon type="plus" />
                    <FormattedMessage id="Component.AccountSettings.List.Action.Create" />
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={this.props.loading.models.projects}>
          <AjaxTable
            updateKey={JSON.stringify([this.state.filter, this.state.removedId])}
            getData={this.getData.bind(this)}
            rowKey="id"
          >
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Account' })}
              dataIndex="name"
              className={styles.tableColumnWrap}
              render={(name, record) => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Account' })}
                >
                  <Link to={`./${record.id}/edit/`} className={styles.TextColor}>
                    {name}
                  </Link>
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Modules' })}
              key="modules"
              dataIndex="modules"
              render={modules => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Modules' })}
                >
                  {modules.length ?
                    <div className="cell-popover">
                      <MultiplyItemsColumnRender itemList={modules.map(i => i.label)} />
                    </div>
                    : <FormattedMessage id="Common.NoData" />
                  }
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Users' })}
              key="roleUsers"
              dataIndex="roleUsers"
              className={styles.tableColumnWrap}
              render={roleUsers => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Users' })}
                >
                  {roleUsers.length ?
                    roleUsers.map((item, index) => {
                      return (
                        <MultiplyItemsColumnRender
                          alignment="start"
                          key={index}
                          numberShowedItems={0}
                          labelName={item.name}
                          itemList={
                            item.usersFiltered.map((i) => {
                              return [_.truncate(i.first_name, { length: 16 }), _.truncate(i.last_name, { length: 16 })].join(' ');
                            })
                          }
                        />
                      );
                    })
                    : <FormattedMessage id="Common.NoData" />}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({
  app,
  loading,
  projects,
}) => ({
  app,
  loading,
  projects,
}))(injectIntl(ProjectsList));



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectsList/ProjectsList.js